import { TextInput } from '@components/shared/forms';
import { useTranslation } from 'react-i18next';
import { ContentBlockWrapper } from '..';

export default function RealtyAds() {
  const { t } = useTranslation('admin');

  return (
    <ContentBlockWrapper
      contentBlockId="realtyAds"
      wrapInDraggable={false}
      title={t('microsite.sections.realtyAds')}
      section="realtyAds"
    >
      <TextInput
        name="realtyAdsPixelSrc"
        labelText={t('microsite.realtyAdsPixelSrc.title')}
        placeholder={t('microsite.realtyAdsPixelSrc.placeholder')}
        description={t('microsite.realtyAdsPixelSrc.description')}
        className="w-full"
      />
    </ContentBlockWrapper>
  );
}
